<script setup lang="ts">
import { NCard, NButton } from 'naive-ui'
import { projectSubmitIcon, meetingIcon, starIcon, interviewIcon, payrollIcon } from "@/assets/utils/icons";

const steps = [
  {
    icon: projectSubmitIcon,
    text: 'Submit your project and positions requirements.',
  },
  {
    icon: meetingIcon,
    text: 'We’ll meet to go over your needs and resolve any questions.',
  },
  {
    icon: starIcon,
    text: 'Our team will personally vet and select the best candidates that best match your needs.',
  },
  {
    icon: interviewIcon,
    text: 'You’ll pick and interview the candidates you love.',
  },
  {
    icon: payrollIcon,
    text: 'We’ll take care of the offer, payroll, and all needed compliance.',
  },
]

</script>

<template>
  <section class="our-process">
    <n-card title="How our process works" size="large" style="margin-bottom: 60px;" embedded :bordered="false">
      <div class="grid-x process-guide">
        <div v-for="(step, i) in steps" class="cell small-12 process-step flex-container" :key="i">
          <div class="process-icon" v-html="step.icon"></div>
          <div class="process-text body-text-rg text-w-bold">
            {{ step.text}}
          </div>
        </div>
      </div>
      <div class="grid-x button-container">
        <router-link class="width-100" :to="{ name: 'meetings' }">
          <n-button :focusable="false" size="large">
            BOOK A MEETING
          </n-button>
        </router-link>
      </div>
    </n-card>
  </section>
</template>

<style lang="scss">
.our-process {
  padding-left: 50px;

  .process-guide {

    .process-step {
      padding-top: 26px;
      padding-bottom: 26px;
      position: relative;

      &:first-child {
        padding-top: 0;
      }

      &:after {
        content: "";
        right: 20px;
        bottom: 0;
        height: 2px;
        width: calc(100% - 95px);
        position: absolute;
        background: $border-color-gradient;
        border-radius: 2px;
      }
    }

    .process-icon {
      min-width: 60px;
      height: 60px;
      padding: 6px;
      background-color: $white;
      border-radius: 10px;
      margin-right: 14px;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .button-container {
    margin-top: 22px;
  }
}
</style>
